// Groupe d'une prestation (assise, canape, literie, tapis) : sert aux pourcentages d'options, aux offerts des formules et aux
// avantages. La liste « groupe -> prestations » de la configuration est posée à la création et aucun écran ne la modifie : une
// prestation ajoutée ensuite n'y figure pas. Pour ne pas perdre silencieusement ses options et ses offerts, on retombe alors sur
// le nom de la prestation. La liste de la configuration reste prioritaire.

const MOTIFS = [
    ['literie', /matelas|t[êe]te de lit|sommier|oreiller/i],
    ['canape', /canap|sofa|clic[- ]?clac/i],
    ['tapis', /moquette|tapis|carpette/i],
    ['assise', /chaise|fauteuil|banquette|tabouret|pouf/i],
];

export function groupeDepuisNom(label) {
    const nom = String(label || '');
    for (const [groupe, motif] of MOTIFS) if (motif.test(nom)) return groupe;
    return null;
}

export function groupeDe(config, itemId, label) {
    for (const [g, ids] of Object.entries(config?.groupes || {})) if ((ids || []).map(String).includes(String(itemId))) return g;
    return groupeDepuisNom(label);
}
